export const ADMIN_ROLES = ["super_admin", "admin"];
export const ADMIN_AND_COORDINATOR = ["super_admin", "admin", "coordinator"];
// /users is reachable by super_admin (full mgmt) and any admin (so they can
// grant permissions). Reviewers and coordinators never see this route.
export const USERS_PAGE_ROLES = ["super_admin", "admin"];
export const SUPER_ADMIN_ONLY = ["super_admin"];

export const ROLE_LABEL = {
  super_admin: "Super Admin",
  admin: "Admin",
  sme_reviewer: "SME Reviewer",
  coordinator: "Coordinator",
};
